export const UPDATE_SPONSORED_REGISTRY = 'UPDATE_SPONSORED_REGISTRY';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/sponsored-registry/constants.es6